import type { FC } from 'react';
import { Image } from '@/components/Image/Image';
import type { ComingSoonProps } from './ComingSoon.types';
import styles from './ComingSoon.module.scss';
const ComingSoon: FC<ComingSoonProps> = ({
  fullscreen
}) => {
  return <div className={cn(styles.root, {
    [styles.fullscreen]: fullscreen
  })} data-sentry-component="ComingSoon" data-sentry-source-file="ComingSoon.tsx">
      <div className={styles.image}>
        <Image src="/assets/comingSoon/images/text.webp" fill alt="Coming Soon" data-sentry-element="Image" data-sentry-source-file="ComingSoon.tsx" />
      </div>
    </div>;
};
export { ComingSoon };